export enum ModalSize {
  Narrow = 'narrow',
  Medium = 'medium',
  Wide = 'wide',
}

export type ModalSizes = `${ModalSize}`;

export enum ModalPosition {
  Center = 'center',
  Left = 'left',
  Right = 'right',
}

export type ModalPositions = `${ModalPosition}`;
